<template>
	<div v-if="isLoading" class="loader-overlay">
		<div class="loader-content">
			<div class="loader-spinner">
				<i class="fas fa-spinner fa-spin"></i>
			</div>
			<div class="loader-message">{{ message }}</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const isLoading = computed(() => store.getters['loader/isLoading'])
const message = computed(() => store.getters['loader/message'])
</script>

<style scoped>
.loader-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.78);
	backdrop-filter: blur(10px);
	-webkit-backdrop-filter: blur(10px);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999;
}

.loader-content {
	background-color: white;
	padding: 2rem;
	border-radius: 8px;
	text-align: center;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.loader-spinner {
	font-size: 2.5rem;
	color: #007bff;
	margin-bottom: 1rem;
}

.loader-message {
	color: #333;
	font-size: 1.1rem;
}
</style>
